import { z } from 'zod';
// Dashboard home contract (SPEC §1.5).
export const countryCountsSchema = z.object({
    countryId: z.string(),
    name: z.string(),
    must: z.number(),
    should: z.number(),
    could: z.number(),
    total: z.number(),
    openMust: z.number(), // Must items not yet done
});
export const weatherDaySchema = z.object({
    date: z.string(),
    tMax: z.number().nullable(),
    tMin: z.number().nullable(),
    precipProb: z.number().nullable(),
    code: z.number().nullable(),
});
export const weatherSchema = z
    .object({
    lat: z.number(),
    lng: z.number(),
    timezone: z.string(),
    currentTemp: z.number().nullable(),
    currentTime: z.string().nullable(),
    days: z.array(weatherDaySchema),
    note: z.string().nullable(),
})
    .nullable();
export const dashboardSchema = z.object({
    start: z.string(),
    end: z.string(),
    tripType: z.string().nullable(),
    daysUntilStart: z.number(),
    totalOpenMust: z.number(),
    counts: z.array(countryCountsSchema),
    weather: weatherSchema,
});
//# sourceMappingURL=dashboard.js.map